/**
 * The Mirror's sections (quest journey API v1 §2 `mirror_sections`): Profile
 * (the server's `about`) and Looks (`conjurings`) come with the Mirror, the
 * Circle when Venus draws, Shared with the Community. No list sent (an old
 * server, a member): everything once the Community is open, only Profile
 * before it (navigation §14, gift bug #36).
 *
 * The tabs were renamed on 2026-10-29 (MIRROR-OUTLINE.md): About → Profile,
 * Shared Readings → Shared, Conjurings → Looks. The server's section keys and
 * the old tab names (a Quest star's `conjurings`) still resolve.
 */
const SECTION_OF_TAB = {
  profile: 'about', about: 'about',
  shared: 'readings', readings: 'readings',
  seekers: 'circle', circle: 'circle',
  looks: 'conjurings', conjurings: 'conjurings',
}
/** The Mirror's own tab key for any name a caller may ask for. */
const TAB_OF = { about: 'profile', profile: 'profile', readings: 'shared', shared: 'shared', circle: 'seekers', seekers: 'seekers', conjurings: 'looks', looks: 'looks' }
export const mirrorTabKey = (t) => TAB_OF[t] || ''

export function mirrorHas (tab, { sections = null, communityOpen = true } = {}) {
  const sec = SECTION_OF_TAB[tab] || tab
  if (sec === 'about') return true
  const list = Array.isArray(sections) ? sections : null
  if (!list) return !!communityOpen
  // Shared has no section of its own: it rides with the Community.
  if (sec === 'readings') return list.includes('readings') || !!communityOpen
  return list.includes(sec)
}
